var _rect, _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgAboutAndusWhoWeAreCustomSystemsIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 48,
    height: 48,
    viewBox: "0 0 48 48",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title === undefined ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, "custom system icon") : title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 1,
    y: 1,
    width: 46,
    height: 46,
    rx: 13,
    fill: "#FFFFFF",
    fillOpacity: 0.06,
    stroke: "#FFFFFF",
    strokeOpacity: 0.15
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M17 9h14v8H17zM8 31h14v8H8zM26 31h14v8H26zM24 17v7M15 24h18M15 24v7M33 24v7",
    fill: "none",
    stroke: "#FFBE4D",
    strokeWidth: 2.2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgAboutAndusWhoWeAreCustomSystemsIcon);
export default __webpack_public_path__ + "static/media/about-andus-who-we-are-custom-systems-icon.740d43ad55f68a170939632b740a190f.svg";
export { ForwardRef as ReactComponent };